<template>
  <div class="sale-running">
    <p class="font-bold text-size-24 text-center">本セールの募集は終了しました</p>
    <button class="btn btn-primary" v-if="sale.hasEntry" @click="handleDownload()">
      応募した商品情報をダウンロード
      <i class="fa fa-download" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import SaleService from '@/services/salemasterservice'
import moment from 'moment'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    sale: {
      type: Object,
      default () {
        return null
      }
    }
  },
  methods: {
    async handleDownload () {
      const logParams = {
        name: eventCode.sale.entry.download,
        properties: {
          saleId: this.sale.saleId
        }
      }
      EventService.postTrackLog(logParams)

      const sellerid = this.$store.getters.getUser.sellerId
      const reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      const filename = `entryList_${this.sale.saleId}_${sellerid}_${reportTime}.csv`
      await SaleService.downloadSaleEntryProducts({ saleId: this.sale.saleId }, filename)
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    }
  }
}
</script>
<style scoped>
.sale-running {
  border: 1px solid #ccc;
  background-color: #eee;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.btn {
  font-size: 18px;
  padding: 6px 50px;
}

@media (max-width: 425px) {
  .btn {
    font-size: 14px;
    padding: 6px 12px;
  }
  .text-size-24 {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryRunning.vue